import { Navigate, useParams } from 'react-router';

import {
  getPartnerApplicationSnapshot,
  usePartnerApplicationById,
} from '~domains/partner-application/entities/application';
import { PartnerApplication } from '~domains/partner-application/widgets/partner-application';

import { ROUTES } from '~shared/config/routes';
import { ErrorScreen } from '~shared/ui/error-screen';
import { Loader } from '~shared/ui/loader';

export const PartnerApplicationEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const { data: application, isError } = usePartnerApplicationById({
    applicationId: id,
  });

  if (application) {
    if (application.status !== 'NEW') {
      return <Navigate to={ROUTES.partner.applicationMenu} replace />;
    }

    return (
      <PartnerApplication
        snapshot={getPartnerApplicationSnapshot(application)}
      />
    );
  }

  if (isError) {
    return <ErrorScreen message="Failed to load application." />;
  }

  return <Loader />;
};
